import type { AssistantActivity, AssistantConfirm } from '@secretario/shared';
import { draftWasHandled } from './assistantDraft.js';

/**
 * Pedidos que o Secretário deixou prontos para a pessoa confirmar (um documento
 * para preparar). O servidor só prepara o pedido; quem manda preparar é o toque
 * dela. Reusa o registro dos rascunhos tratados.
 */
export function pendingConfirm(
  activities: AssistantActivity[],
): { activityId: string; confirm: AssistantConfirm } | null {
  for (let index = activities.length - 1; index >= 0; index -= 1) {
    const activity = activities[index];
    if (activity?.confirm && !draftWasHandled(activity.id)) {
      return { activityId: activity.id, confirm: activity.confirm };
    }
  }
  return null;
}
